export default __webpack_public_path__ + "media/morning-street-car-passing-by-birds-singing-63924.ccde103d.mp3";